exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thought-title-field {\n  min-width: 300px; }\n\n.file-input-group {\n  position: relative; }\n\n.hidden-file-input {\n  opacity: 0;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 200px; }\n\n.fake-file-input {\n  cursor: pointer;\n  display: inline-block;\n  padding: 2em 1em;\n  border: 2px dashed #ccc;\n  text-align: center;\n  width: 200px; }\n\n.field-long-text {\n  width: 100%;\n  margin: 0 0 0 3em; }\n\n.field-delete {\n  margin: 1em 1em 1em auto; }\n\n.add-info {\n  display: inline-block; }\n\n.add-info-icon {\n  display: inline-block;\n  width: 20px; }\n\n.modal-body {\n  padding: 1rem 2rem 2rem; }\n\n.dropup .dropdown-menu {\n  top: -200px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/thought-form/thought-form.component.scss
// module id = ../../../../../src/app/thought-module/thought-form/thought-form.component.scss
// module chunks = main